import React, { Component } from 'react';

import Core from './../../../Core/Core';
import Header from './../../Header';
import Alerts from './../../Alert/Alerts';

import ErrorBoundary from '../ErrorBoundary';

class Alert extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            "clients" : [],
            "loading" : true,
        }

        this.load = this.load.bind(this);
        this.load();
    }

    load()
    {
        let date = new Date();
        date.setMonth(date.getMonth()-14);
        let start = Math.round(date.setHours(0,0,0,0)/1000);
        let end = Math.round(date.setHours(23,59,59,999)/1000);
        let request = Core.Address+"Search/Car->date_delivery ge "+start+" and Car->date_delivery le "+end+" and Car->contract_type eq 0";
        
        Core.Instance.Request(request, null, "GET")
        .then((json) => {
            this.setState({
                "clients" : json != null ? json : {},
                "loading": false
            })
        });
    }

    componentDidMount()
    {
        document.title = "W-F: Alertes";
    }


    render()
    {
        return (
            <ErrorBoundary>
                <Header />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                { this.state.clients.length > 0 && 
                                    <div className="card-body">
                                        <h4 className="card-title mb-2">
                                            Livraison(s) aujourd'hui
                                            <span className="badge badge-pill bg-green text-white ml-2">
                                                { this.state.clients.length }
                                            </span> 
                                        </h4>
                                        <Alerts clients={ this.state.clients }/>
                                    </div>
                                }
                                { 
                                    this.state.loading &&
                                    <div className="spinner-border text-info mx-auto" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                }
                                { 
                                    !this.state.loading && !this.state.clients.length &&
                                    <span className="card-body text-center h5 p-0" role="alert">
                                        Aucune livraison de prévue aujourd'hui
                                    </span>
                                }
                               
                            </div> 
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

export default Alert;


// WEBPACK FOOTER //
// ./src/Components/Views/Alert/Alert.js